import { __rest } from "tslib";
export const createNode = (_a) => {
    var { tag = 'div' } = _a, attrs = __rest(_a, ["tag"]);
    const node = document.createElement(tag);
    if (Object.keys(attrs).length > 0) {
        for (const key in attrs) {
            const value = attrs[key];
            if (value)
                node.setAttribute(key, value);
        }
    }
    return node;
};
